var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.95 184.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke: #c9c9c9;\n        stroke-miterlimit: 10;\n        stroke-width: .16px;\n      }\n\n      .cls-2 {\n        fill: #cc0202;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 97.91,
    y: 87.04,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.04,
    y: 97.91,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.04,
    y: 87.04,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.17,
    y: 87.04,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.04,
    y: 76.17,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.26,
    y: 10.95,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.13,
    y: 21.82,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.26,
    y: 21.82,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 163.13,
    y: 54.43,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 163.13,
    y: 43.56,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 174,
    y: 43.56,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 163.13,
    y: 10.95,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.26,
    y: 43.56,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.26,
    y: 54.43,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 141.39,
    y: 54.43,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.26,
    y: 65.3,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 141.39,
    y: 65.3,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.52,
    y: 65.3,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 141.39,
    y: 76.17,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.52,
    y: 76.17,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.65,
    y: 76.17,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 141.39,
    y: 43.56,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.52,
    y: 54.43,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.65,
    y: 65.3,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.78,
    y: 76.17,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.78,
    y: 54.43,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.91,
    y: 54.43,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.91,
    y: 65.3,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.91,
    y: 43.56,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.78,
    y: 43.56,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.78,
    y: 32.69,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.65,
    y: 43.56,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.65,
    y: 32.69,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.65,
    y: 21.82,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.52,
    y: 32.69,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.52,
    y: 21.82,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.52,
    y: 10.95,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.91,
    y: 32.69,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.78,
    y: 21.82,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.65,
    y: 10.95,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.52,
    y: 0.08,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.26,
    y: 163.13,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.13,
    y: 152.26,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.26,
    y: 152.26,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 163.13,
    y: 119.65,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 163.13,
    y: 130.52,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 174,
    y: 130.52,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 163.13,
    y: 163.13,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.26,
    y: 130.52,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.26,
    y: 119.65,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 141.39,
    y: 119.65,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.26,
    y: 108.78,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 141.39,
    y: 108.78,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.52,
    y: 108.78,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 141.39,
    y: 97.91,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.52,
    y: 97.91,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.65,
    y: 97.91,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 141.39,
    y: 130.52,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.52,
    y: 119.65,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.65,
    y: 108.78,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.78,
    y: 97.91,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.78,
    y: 119.65,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.91,
    y: 119.65,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.91,
    y: 108.78,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.91,
    y: 130.52,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.78,
    y: 130.52,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.78,
    y: 141.39,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.65,
    y: 130.52,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.65,
    y: 141.39,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.65,
    y: 152.26,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.52,
    y: 141.39,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.52,
    y: 152.26,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.52,
    y: 163.13,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.91,
    y: 141.39,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.78,
    y: 152.26,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.65,
    y: 163.13,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.52,
    y: 173.99,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.82,
    y: 163.13,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.95,
    y: 152.26,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.82,
    y: 152.26,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.95,
    y: 119.65,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.95,
    y: 130.52,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.08,
    y: 130.52,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.95,
    y: 163.13,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.82,
    y: 130.52,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.82,
    y: 119.65,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.69,
    y: 119.65,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.82,
    y: 108.78,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.69,
    y: 108.78,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.56,
    y: 108.78,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.69,
    y: 97.91,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.56,
    y: 97.91,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.43,
    y: 97.91,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.69,
    y: 130.52,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.56,
    y: 119.65,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.43,
    y: 108.78,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.3,
    y: 97.91,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.3,
    y: 119.65,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.17,
    y: 119.65,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.17,
    y: 108.78,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.17,
    y: 130.52,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.3,
    y: 130.52,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.3,
    y: 141.39,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.43,
    y: 130.52,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.43,
    y: 141.39,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.43,
    y: 152.26,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.56,
    y: 141.39,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.56,
    y: 152.26,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.56,
    y: 163.13,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.17,
    y: 141.39,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.3,
    y: 152.26,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.43,
    y: 163.13,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.56,
    y: 173.99,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.82,
    y: 10.95,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.95,
    y: 21.82,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.82,
    y: 21.82,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.95,
    y: 54.43,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.95,
    y: 43.56,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.08,
    y: 43.56,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.95,
    y: 10.95,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.82,
    y: 43.56,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.82,
    y: 54.43,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.69,
    y: 54.43,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.82,
    y: 65.3,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.69,
    y: 65.3,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.56,
    y: 65.3,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.69,
    y: 76.17,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.56,
    y: 76.17,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.43,
    y: 76.17,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.69,
    y: 43.56,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.56,
    y: 54.43,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.43,
    y: 65.3,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.3,
    y: 76.17,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.3,
    y: 54.43,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.17,
    y: 54.43,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.17,
    y: 65.3,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.17,
    y: 43.56,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.3,
    y: 43.56,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.3,
    y: 32.69,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.43,
    y: 43.56,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.43,
    y: 32.69,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.43,
    y: 21.82,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.56,
    y: 32.69,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.56,
    y: 21.82,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.56,
    y: 10.95,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.17,
    y: 32.69,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.3,
    y: 21.82,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.43,
    y: 10.95,
    width: 10.87,
    height: 10.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.56,
    y: 0.08,
    width: 10.87,
    height: 10.87
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset5);
export default __webpack_public_path__ + "static/media/Asset5.34462dac6eb90ae70db670a1d3125da1.svg";
export { ForwardRef as ReactComponent };